/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingListRequest {
    getFixupPrototypeFunction() { return AwsSecurityHubFindingListRequest.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingListRequest>): AwsSecurityHubFindingListRequest {
        let obj = Object.assign(new AwsSecurityHubFindingListRequest(), model);
        AwsSecurityHubFindingListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingListRequest>): AwsSecurityHubFindingListRequest {
        if (!model) return null;
        return AwsSecurityHubFindingListRequest.newInstance(<AwsSecurityHubFindingListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingListRequest) {
        if (!obj) return;

        models.AwsSecurityHubFindingListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingListRequest): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFindingListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.AwsSecurityHubFindingFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.AwsSecurityHubFindingSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.AwsSecurityHubFindingSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.AwsSecurityHubFindingFilters;

}
